import { createFileRoute } from '@tanstack/react-router'
import { Layers } from 'lucide-react'

import { PageEmpty } from '../components/PageEmpty.js'

export const Route = createFileRoute('/review')({
  component: () => <PageEmpty page="review" icon={Layers} />,
})
